import {useOS} from '@aboutyou/utils';
import {useId} from 'react';
import {usePreventScroll} from 'react-aria';
import {useIsomorphicLayoutEffect} from '../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect';

let activeInstanceId: string | null = null;

export const useLockBodyScroll = ({lockScroll}: {lockScroll: boolean}) => {
  const instanceId = useId();
  const isAndroid = useOS() === 'android';
  const isIos = useOS() === 'ios';

  useIsomorphicLayoutEffect(() => {
    if (!lockScroll || activeInstanceId) {
      return;
    }

    activeInstanceId = instanceId;

    // To address the issue where sometimes the page is not scrollable in Chrome for Android
    // after changing the body overflow style, we keep the body overflow to auto.
    // Overflow hidden is still set on the html element by usePreventScroll to prevent the page from scrolling.
    if (isAndroid) {
      document.body.style.overflow = 'auto';
    }

    if (isIos) {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100vw';
      document.body.style.height = '100vh';
    }

    return () => {
      if (activeInstanceId !== instanceId) {
        return;
      }

      activeInstanceId = null;

      if (isIos) {
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('width');
        document.body.style.removeProperty('height');
      }
    };
  }, [lockScroll, isAndroid, isIos, instanceId]);

  usePreventScroll({isDisabled: !lockScroll});
};
